<template>
    <svg
        v-if="$widgetUI=='OLD-UI' || uiobject=='old'"
        :height="h"
        :width="w"
        :class="[color, directionClass, {'absolute': !arrowBtn}]"
        viewBox="0 0 1792 1792"
        class="fill-current transition-all icon-arrow">
        <path
            d="M1683 1331l-166 165q-19 19-45 19t-45-19l-531-531-531 531q-19 19-45 19t-45-19l-166-165q-19-19-19-45.5t19-45.5l742-741q19-19 45-19t45 19l742 741q19 19 19 45.5t-19 45.5z"/>
    </svg>
    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" :height="h"
        :width="w"
        :class="[color, directionClass, {'absolute': !arrowBtn}]">
        <path fill-rule="evenodd" d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z" clip-rule="evenodd" />
    </svg>

</template>

<script>
export default {
    name: "icon-arrow",
    props: {
        w: {
            type: Number,
            default: 16
        },
        h: {
            type: Number,
            default: 16
        },
        color: {
            type: String,
            default: "text-gray-500"
        },
        direction: {
            type: String,
            default: "top"
        },
        arrowBtn: {
            type: Boolean,
            default: false
        },
        uiobject: {
            type: String,
            default: "new"
        }
    },
    computed: {
        directionClass() {
            if (this.direction === "left") {
                return "icon-arrow-direction-left";
            }
        }
    }
};
</script>
